import CardDefault from "components/Cards/CardDefault/index";
import { Flex } from "@chakra-ui/react";
import { Empty } from "antd";

interface ContabilizacaoTableProps {
  headerTable: React.ReactNode;
  rowTable?: React.ReactNode;
  borderTopRadius?: number;
}
export default function ContabilizacaoTable({
  headerTable,
  rowTable,
  borderTopRadius = 15,
}: ContabilizacaoTableProps) {
  console.log(rowTable);

  return (
    <CardDefault p="0">
      <Flex
        bg="#f0f0f0"
        px={8}
        py={2}
        h="60px"
        borderTopRadius={borderTopRadius}
        align="center"
      >
        {headerTable}
      </Flex>
      {rowTable || <Empty description="Sem dados para exportar" />}
      <Flex bg="#f0f0f0" h="20px" borderBottomRadius={15}></Flex>
    </CardDefault>
  );
}
